export default "__VITE_ASSET__8mSp0N16__"